import { useMatch } from "react-router-dom";

import { Goto } from "@/shared/navigation/Goto";

import { VizExternalLink } from "./VizExternalLink.tsx";
import { VizInternalLink } from "./VizInternalLink.tsx";

interface AISummaryMarkdownLinkProps {
  datasetId?: string;
  fileId?: string;
  topicId?: string;
  messagePathId?: string;
  time?: bigint;
  text: string;
  onLinkClick?: () => void;
}

export const AISummaryMarkdownLink = ({
  datasetId,
  fileId,
  topicId,
  messagePathId,
  time,
  text,
  onLinkClick,
}: AISummaryMarkdownLinkProps) => {
  // Check if we're on the visualizer page. This specific check is much cheaper than subscribing to
  // useViewingContext and works well enough, but can always be replaced in the future.
  const isInVisualizer = useMatch(`${Goto.route.Visualize}/:workspaceId?`);

  // If we have a topic ID, we can render a "
  if (isInVisualizer && (topicId || messagePathId || time)) {
    return (
      <VizInternalLink
        messagePathId={messagePathId}
        topicId={topicId}
        text={text}
        time={time}
      />
    );
  } else {
    return (
      <VizExternalLink
        datasetId={datasetId}
        fileId={fileId}
        topicId={topicId}
        messagePathId={messagePathId}
        text={text}
        time={time}
        onLinkClick={onLinkClick}
      />
    );
  }
};
